<template>
  <v-card
    flat
    color="transparent"
    class="mt-n4"
  >
    <!-- :color="errorMessage.length > 0 ? 'pink lighten-5' : 'transparent'" -->
    <v-row>
      <v-col cols="12">
        <v-text-field
          :type="fieldType"
          outlined
          filled
          dense
          :placeholder="$t('단답형 텍스트')"
          v-model="questionAnswer"
          :error-messages="errorMessage"
          :color="themeColor"
          maxlength="500"
        ></v-text-field>
        <span>{{textLenght + " / 500 자"}}</span>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { validate } from "vee-validate";
export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
    },
    isValid: {
      type: Boolean,
      default: false,
    },
    themeColor: {
      type: String,
      default: "primary"
    },
    responseAnswer: Object,
  },
  computed: {
    textLenght(){
      let t = this.questionAnswer?this.questionAnswer.length:0;
      return t;
    },
    fieldType() {
      if(!this.validationOptions) return "text";
      switch (this.validationOptions.textType) {
        case "NUMBER":
          return "number";

        case "TEXT":
        default:
          return "text";
      }
    },
    questionAnswers() {
      let qa = null;
      if (this.questionAnswer != null) {
        qa = [this.questionAnswer];
      } else {
        qa = [];
      }
      return {
        questionId: this.question.questionId,
        questionMatrixId: null,
        questionAnswerVals: qa,
        questionType: this.question.questionType
      };
    },
  },
  data() {
    return {
      questionAnswer: null,
      validationOptions: JSON.parse(this.question.validationOptions),
      errorMessage: [],
      // isValid: false,
    };
  },
  methods: {
    async checkValidation() {
      const textType = this.validationOptions ? this.validationOptions.textType: null;
      let rules = {};

      if (this.question.required) {
        rules["required"] = true;
      }
      if (
        textType == "TEXT" &&
        this.validationOptions.lengthValidType &&
        this.validationOptions.limitLength
      ) {
        switch (this.validationOptions.lengthValidType) {
          case "LIMIT_MIN_LENGTH":
            rules["min"] = this.validationOptions.limitLength;
            break;
          case "LIMIT_MAX_LENGTH":
            rules["max"] = this.validationOptions.limitLength;
            break;
          case "LIMIT_FIX_LENGTH":
            rules["length"] = this.validationOptions.limitLength;
            break;
          default:
            break;
        }
      } else if (
        textType == "NUMBER" &&
        this.validationOptions.numberValidType &&
        (this.validationOptions.limitMinVal ||
          this.validationOptions.limitMaxVal ||
          this.validationOptions.limitFixVal)
      ) {
        switch (this.validationOptions.numberValidType) {
          case "LIMIT_MIN_VALUE":
            rules["min_value"] = this.validationOptions.limitMinVal;
            break;
          case "LIMIT_MAX_VALUE":
            rules["max_value"] = this.validationOptions.limitMaxVal;
            break;
          case "LIMIT_RANGE_VALUE":
            if (
              null != this.validationOptions.limitMinVal &&
              null != this.validationOptions.limitMaxVal
            ) {
              rules["between"] = {
                min: this.validationOptions.limitMinVal,
                max: this.validationOptions.limitMaxVal,
              };
            } else if (
              null != this.validationOptions.limitMinVal &&
              null == this.validationOptions.limitMaxVal
            ) {
              rules["min_value"] = this.validationOptions.limitMinVal;
            } else if (
              null == this.validationOptions.limitMinVal &&
              null != this.validationOptions.limitMaxVal
            ) {
              rules["max_value"] = this.validationOptions.limitMaxVal;
            }
            break;
          case "LIMIT_FIX_VALUE":
            rules["is"] = this.validationOptions.limitFixVal.toString();
            break;
          default:
            break;
        }
      } else if (textType == "EMAIL") {
        // EMAIL타입 검증
        rules["email"] = true;
      } else if (textType == "URL") {
        // URL타입 검증
        rules["url"] = true;
      }
      let rst = await validate(this.questionAnswer, rules, { name: "이 " });
      this.$emit("update:isValid", rst.valid);
      this.errorMessage = rst.errors;
    },
    setQuestionAnswer() {
      this.questionAnswer =
        this.responseAnswer.response && this.responseAnswer.response.length > 0
          ? this.responseAnswer.response[0].answerVal
          : null;
    },
  },
  watch: {
    async questionAnswer() {
      await this.checkValidation();
      this.$emit("input", this.questionAnswers);
    },
  },
  mounted() {
    if (this.responseAnswer) {
      this.setQuestionAnswer();
    }
    this.$emit("input", this.questionAnswers);
  },
};
</script>

<style>
</style>